import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import classNames from 'classnames/bind';
import styles from './BackToTopButton.module.scss';

const cx = classNames.bind(styles);

const BackToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Kiểm tra vị trí scroll và hiển thị nút khi scroll xuống đủ xa
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Xử lý sự kiện scroll to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <>
            {isVisible && (
                <button className={cx('back-to-top')} onClick={scrollToTop} aria-label="Cuộn lên đầu trang">
                    <ArrowUp size={20} strokeWidth={2.5} />
                </button>
            )}
        </>
    );
};

export default BackToTopButton;
